import { render, staticRenderFns } from "./BreadCrumb2.vue?vue&type=template&id=6b33880d&scoped=true"
import script from "./BreadCrumb2.vue?vue&type=script&lang=js"
export * from "./BreadCrumb2.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumb2.vue?vue&type=style&index=0&id=6b33880d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33880d",
  null
  
)

export default component.exports